import React from 'react'
import { IoDiamond } from 'react-icons/io5'
import classNames from 'classnames'
import { Button } from 'react-bootstrap'

const FreemiumCard = () => {
  return (
    <div className="subscription-card">

      <div className="subscription-card__icon">
        <IoDiamond size={18} />
      </div>
      <div className="subscription-card__content">

        <div className="subscription-card__header">

          <h2 className="subscription-card__title">
            Freemium 100 credits
          </h2>
          <button
            className="subscription-card__link-button"
            disabled={true}
          >
            What&apos;s Included?
          </button>

        </div>
        <div className="subscription-card__description">
          You are on a free plan
        </div>
        <div className="subscription-card__info-row">
          <span>Credits</span>
          <span>100 one time</span>
        </div>
        <div className="subscription-card__info-row">
          <span>Status</span>
          <span className="subscription-card__status subscription-card__status--active">
            Active
          </span>
        </div>
        <div className="subscription-card__footer">

          <Button
            className={classNames(
              'subscription-card__primary-button',
              {
                'subscription-card__primary-button--disabled': true
              }
            )}
            variant='outline-primary'
            disabled={true}
          >
            Upgrade
          </Button>

        </div>

      </div>

    </div>
  )
}

export default FreemiumCard